export default __webpack_public_path__ + "static/media/info-4.92ddb226.png";